export const filterOption = (input, option) => {
  if (option.options) {
    return false;
  }

  return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
};
